<mat-card>
  <mat-toolbar-row>
    <h3>{{ 'Console' | translate }}</h3>
    <div class="actions action-icon">
      <button
        *ixRequiresRoles="requiredRoles"
        mat-button
        [ixTest]="['console', 'configure']"
        (click)="onConfigurePressed()"
      >
        {{ 'Configure' | translate }}
      </button>
    </div>
  </mat-toolbar-row>

  <mat-card-content>
    <mat-list>
      <mat-list-item>
        <span class="label">{{ 'Show Text Console without Password Prompt' | translate }}:</span>
        <span *ixWithLoadingState="advancedConfig$ as advancedConfig" class="value">
          {{ advancedConfig.consolemenu ? ('Enabled' | translate) : ('Disabled' | translate) }}
        </span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">{{ 'Enable Serial Console' | translate }}:</span>
        <span *ixWithLoadingState="advancedConfig$ as advancedConfig" class="value">
          {{ advancedConfig.serialconsole ? ('Enabled' | translate) : ('Disabled' | translate) }}
        </span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">{{ 'Serial Port' | translate }}:</span>
        <span *ixWithLoadingState="advancedConfig$ as advancedConfig" class="value">
          {{ advancedConfig.serialport || '–' }}
        </span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">{{ 'Serial Speed' | translate }}:</span>
        <span *ixWithLoadingState="advancedConfig$ as advancedConfig" class="value">
          {{ advancedConfig.serialspeed ? (advancedConfig.serialspeed + ' bps') : '–' }}
        </span>
      </mat-list-item>
      <mat-list-item>
        <span class="label">{{ 'MOTD Banner' | translate }}:</span>
        <span *ixWithLoadingState="advancedConfig$ as advancedConfig" class="value">
          {{ advancedConfig.motd || '–' }}
        </span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
